<div class="section-header">
    <!-- Default header content -->
    <ng-content select="[header]"></ng-content>

    <!-- Fallback to default title component if no header content provided -->
    @if (title) {
    <app-dashboard-title [title]="title"
                         [tooltipText]="tooltipText"
                         [subtitle]="subtitle">
    </app-dashboard-title>
    }

    <div class="header-actions">
        <!-- Custom action buttons -->
        <span class="actions">
            <ng-content select="[actions]"></ng-content>
        </span>
        @if (showExpandButton) {
        <button type="button"
                class="btn btn-link expansion-toggle"
                (click)="toggleExpanded()"
                [attr.aria-expanded]="expanded"
                [attr.aria-label]="
                    expanded ? 'Collapse section' : 'Expand section'
                ">
            @if (showButtonText) {
            {{ expanded ? "Collapse" : "Expand" }}
            }
            @if (expanded) {
            <img src="assets/svg/icons/keyboard-arrow-up.svg"
                 alt=""
                 aria-hidden="true" />
            } @else {
            <img src="assets/svg/icons/keyboard-arrow-down.svg"
                 alt=""
                 aria-hidden="true" />
            }
        </button>
        }
    </div>
</div>
<div class="section-content"
     [@slideDown]="expanded ? 'expanded' : 'collapsed'"
     [attr.aria-hidden]="!expanded"
     [attr.inert]="!expanded ? '' : null">
    <ng-content></ng-content>
</div>
